import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import ReportHandler from "../../../report";
import EssenceFiles from "../../Essence/EssenceFiles";
import Blocker from "../../Misc/Blocker";
import ReportForm from "./ReportForm";
export default class ReportItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      initResult: {},
      buildResult: {},
      reportHandler: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  onMutate = async (formData) => {
    this.setState({ pending: true });
    if (this.state.reportHandler.uuid) {
      await this.state.reportHandler.buildForm(formData);
    }
    this.setState({ pending: false });
  };

  load = async () => {
    this.setState({ pending: true });
    let initResult = {};
    let buildResult = {};
    let reportHandler = {};
    if (this.props.itemId) {
      reportHandler = new ReportHandler(this.props.itemId);
      initResult = await reportHandler.init();
    }
    this.setState({ pending: false, initResult, reportHandler, buildResult });
  };

  submit = async (formData) => {
    this.setState({ pending: true });
    let buildResult = {};

    if (this.state.reportHandler.uuid) {
      buildResult = await this.state.reportHandler.build(formData);
    }
    this.setState({ pending: false, buildResult });
  };

  render() {
    const { pending, reportHandler, buildResult } = this.state;
    return (
      <>
        <Blocker hAuto spinnerFixed on={pending}>
          {this.props.itemId && (
            <>
              <ReportForm
                form={reportHandler.form || {}}
                onSubmit={this.submit}
                onMutate={this.onMutate}
              />
              {buildResult.id && (
                <>
                  <EssenceFiles
                    listOnly
                    essence="report"
                    id={buildResult.id}
                    key={buildResult.id}
                  />
                </>
              )}
              {buildResult.html && (
                <>
                  <hr />
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: buildResult.html || "",
                    }}
                  ></div>
                </>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
